import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_PATIENT_THERAPY_PLANNING_FAILURE,
  GET_PATIENT_THERAPY_PLANNING_LOADING,
  GET_PATIENT_THERAPY_PLANNING_REQUEST,
  GET_PATIENT_THERAPY_PLANNING_SUCCESS,
} = therapyPlanningAction;

function* getTherapyPlanningPatient(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PATIENT_THERAPY_PLANNING_LOADING });
    const response = yield call(therapyPlanningService.getTherapyPlanningPatient, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_PATIENT_THERAPY_PLANNING_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PATIENT_THERAPY_PLANNING_FAILURE, payload: error });
  }
}

function* getTherapyPlanningPatientSaga() {
  yield takeEvery(GET_PATIENT_THERAPY_PLANNING_REQUEST, getTherapyPlanningPatient);
}

export default getTherapyPlanningPatientSaga;
